
import React from "react";
import classes from "./Receipts.module.css";
import { Spinner } from 'react-bootstrap';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  subtitle,
  children,
  // Add all the necessary props
  addPayment2,
  addpaymenntLoad2,
  invoiceOptions,
  selectedInvoice,
  setSelectedInvoice,
  setAmount,
  amount,
  paymentDate,
  setPaymentDate,
  description,
  setDescription,
  paymentMode,
  selectedPaymentMode,
  setSelectedPaymentMode,
  currencyOptions,
  selectedCurrency,
  setSelectedCurrency,
  bankOptions,
  selectedBank,
  setSelectedBank,
  bankOptions2,
  selectedBank2,
  setSelectedBank2,
  classes: classesProp
}) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div
        className={classes.modalDialog}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.modalHeader}>
          <div className={classes.modalHeaderText}>
            <h5 className={classes.modalTitle}>{title}</h5>
            {subtitle ? <div className={classes.sub}>{subtitle}</div> : null}
          </div>
          <button className={classes.modalClose} onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={classes.modalBody}>
          {children}
        </div>
        <div className={classes.modalFooter}>
          <button className={classes.modalBtnSecondary} onClick={onClose}>
            Go back
          </button>
          <button 
            onClick={addPayment2} 
            disabled={addpaymenntLoad2}  
            className={classes.modalBtnPrimary}
          > 
            {addpaymenntLoad2 ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>
                  Processing, Please wait...
                </span>
              </>
            ) : (
              "Save Payment"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
